import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { mapModeStore } from "./map-mode-store";

const authStore = new Vuex.Store({
  state: {
    token: "",
    rawToken: "",
    name: "",
    department: "",
    authLevel: 0,
    orgType: null,
    first_login: false,
    invoiceAllowedFlag: 0,
  },
  mutations: {
    updateRespProfile(state, respData) {
      authStore.commit("updateName", respData.value.name);
      authStore.commit("updateDepartment", respData.value.department);
      authStore.commit("updateAuthLevel", respData.value.auth);
      authStore.commit("updateMyAccount", respData.value);
      authStore.commit("updateOrgType", respData.value.org_type);
    },
    updateToken(state, token) {
      state.token = token;
      const tokenArray = token.split(" ");
      state.rawToken = tokenArray[1];
    },
    updateTokenFromParam(state, token) {
      if (state.token) {
        state.token = +"Bearer" + token;
      } else {
        state.token = "Bearer " + token;
      }
      state.rawToken = token;
    },
    clearToken(state) {
      state.token = "";
      state.rawToken = "";
    },
    updateName(state, name) {
      state.name = name;
    },
    updateDepartment(state, department) {
      state.department = department;
    },
    updateAuthLevel(state, authLevel) {
      state.authLevel = authLevel;
    },
    updateOrgType(state, orgType) {
      state.orgType = orgType;
    },
  },
  getters: {
    isAuthorized: (state) => state.token.length > 0,
    rawToken: (state) => state.rawToken,
    mapUrl: (state) => {
      //  alert("z" + mapModeStore.getters.mode + mapModeStore.getters.mapUrlOption)
      return state.rawToken + mapModeStore.getters.mapUrlOption;
    },
    mapUrlOrikomi: (state) => {
      return state.rawToken + mapModeStore.getters.mapUrlOptionOrikomi;
    },
    authLevel: (state) => state.authLevel,
    orgType: (state) => state.orgType,
  },
  plugins: [createPersistedState()],
});

export { authStore };
